import banner from "../../../courses/module-1/img5.png";

const modulo5_pt = {
  courseId: "finanzas-personales",
  id: "modulo-5", // ⚠️ Mesmo ID
  title: "📘 MÓDULO 5: Introdução ao Investimento",
  estimatedDuration: "2 horas",
  format: "Leitura + simulação escrita + avaliação",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivos do módulo",
      content: [
        "Entender o que realmente significa investir (sem mitos ou promessas milagrosas).",
        "Descobrir como o juros composto multiplica seu dinheiro ao longo do tempo.",
        "Conhecer opções de investimento seguras, acessíveis e populares no Brasil.",
        "Aplicar princípios de risco, retorno e diversificação de forma responsável.",
      ],
    },
    {
      id: "lectura",
      navLabel: "Leitura principal",
      title: "📖 Leitura principal: O que significa investir?",
      content: [
        {
          type: "paragraph",
          text: "📌 Definição básica",
        },
        {
          type: "paragraph",
          text: "Investir é usar parte do seu dinheiro para colocá-lo para trabalhar, com a expectativa de que ele cresça com o tempo.",
        },
        {
          type: "paragraph",
          text: "Não é sobre enriquecer rápido — é sobre fazer escolhas inteligentes e constantes.",
        },
        {
          type: "paragraph",
          text: "👉 “Guardar é proteger. Investir é fazer crescer.”",
        },
      ],
    },
    {
      id: "comparacion",
      navLabel: "Poupança vs Investimento",
      title: "💬 Qual a diferença entre poupar e investir?",
      content: [
        {
          type: "table",
          headers: ["Poupança", "Investimento"],
          rows: [
            ["Protege o dinheiro", "Faz o dinheiro crescer"],
            ["Risco baixo ou nulo", "Existe algum risco"],
            ["Dinheiro disponível na hora", "Demanda tempo para render"],
            ["Ideal para curto prazo", "Ideal para médio e longo prazo"],
          ],
        },
      ],
    },
    {
      id: "interes-compuesto",
      navLabel: "Juro Composto",
      title: "💸 A Lei dos Juros Compostos: seu superpoder financeiro",
      content: [
        {
          type: "paragraph",
          text: "“Juros compostos são a oitava maravilha do mundo.” – (atribuído a Einstein)",
        },
        {
          type: "paragraph",
          text: "📌 O que são?",
        },
        {
          type: "paragraph",
          text: "São os juros sobre os juros que vão sendo acumulados ao longo do tempo.",
        },
        {
          type: "paragraph",
          text: "Quanto mais cedo você começa, maior o efeito multiplicador.",
        },
        {
          type: "paragraph",
          text: "🎯 Exemplo simples:",
        },
        {
          type: "paragraph",
          text: "Se você investe R$ 1.000 com rendimento de 10% ao ano:",
        },
        {
          type: "list",
          items: [
            "Ano 1 → R$ 1.100",
            "Ano 2 → R$ 1.210",
            "Ano 3 → R$ 1.331",
            "Ano 10 → R$ 2.594",
            "Ano 20 → R$ 6.727",
          ],
        },
        {
          type: "paragraph",
          text: "👉 A mágica está no tempo, não no valor inicial.",
        },
      ],
    },
    {
      id: "riesgo-rentabilidad",
      navLabel: "Risco e rentabilidade",
      title: "⚖️ Lei do Risco e Retorno",
      content: [
        {
          type: "paragraph",
          text: "Toda inversión envolve uma relação direta:",
        },
        {
          type: "paragraph",
          text: "📌 Quanto maior o retorno potencial, maior o risco. Quanto menor o risco, menor o retorno.",
        },
        {
          type: "table",
          headers: [
            "Tipo de investimento",
            "Risco",
            "Ganho potencial",
            "Exemplo",
          ],
          rows: [
            ["Conta poupança", "Muito baixo", "Baixo", "Banco tradicional"],
            [
              "Tipo de investimento (BR)",
              "Nível de risco",
              "Retorno potencial",
              "Exemplo",
            ],
            ["Poupança", "Baixíssimo", "Baixa", "Bancos"],
            [
              "Tesouro Direto (Selic, IPCA)",
              "Baixo",
              "Baixa a moderada",
              "Governo Federal",
            ],
            ["CDB, LCI/LCA", "Baixo a médio", "Moderada", "Bancos e fintechs"],
            [
              "Fundos e ETFs",
              "Médio",
              "Moderada a alta",
              "Renda fixa/variável",
            ],
            [
              "Ações / Cripto / Renda variável",
              "Alto",
              "Alta",
              "Bolsa, Bitcoin",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "📌 Como reduzir risco?",
        },
        {
          type: "list",
          items: [
            "Invista apenas o que você não precisa no curto prazo",
            "Diversifique (não coloque tudo no mesmo tipo de investimento)",
            "Comece pelo simples e seguro",
            "Se informe antes de investir em algo mais arriscado",
          ],
        },
      ],
    },
    // {
    //   id: "reducir-riesgo",
    //   navLabel: "Reduzir risco",
    //   title: "📌 Como reduzir o risco?",
    //   content: [
    //     {
    //       type: "list",
    //       items: [
    //         "Invista apenas o que não vai precisar no curto prazo.",
    //         "Diversifique: não coloque todos os ovos na mesma cesta.",
    //         "Informe-se antes de agir.",
    //         "Comece pelos investimentos mais seguros antes de buscar grandes rendimentos.",
    //       ],
    //     },
    //   ],
    // },
    {
      id: "regla-110",
      navLabel: "Regra 110",
      title: "🔢 Extra: Regra dos 110",
      content: [
        {
          type: "paragraph",
          text: "É uma fórmula simples que ajuda a estimar quanto do seu dinheiro pode ir para investimentos de maior risco.",
        },
        {
          type: "paragraph",
          text: "📌 Como funciona?",
        },
        {
          type: "paragraph",
          text: "110 − sua idade = % recomendada para investimentos mais arriscados",
        },
        {
          type: "paragraph",
          text: "👇 Exemplo prático:",
        },
        {
          type: "list",
          items: ["Se você tem 20 anos:"],
        },
        "110 − 20 = 90 → até 90% em ativos de maior risco (ações, ETFs etc.)",
        {
          type: "list",
          items: ["Se você tem 30 anos:"],
        },
        "110 − 30 = 80 → até 80% em maior risco e o restante em segurança",
        {
          type: "paragraph",
          text: "Não é regra obrigatória — é apenas um guia de equilíbrio.",
        },
      ],
    },
    {
      id: "ejercicio",
      navLabel: "Exercício prático",
      title: "🧠 Exercício prático: simulação de crescimento",
      content: [
        {
          type: "paragraph",
          text: "Imagine que você consegue investir R$ 50 por mês em Tesouro Selic, com rendimento médio anual de 15% (valor aproximado para fins didáticos).",
        },
        {
          type: "paragraph",
          text: "Qual seria o resultado em 1, 3 e 5 anos usando juros compostos?",
        },
        {
          type: "paragraph",
          text: "Use a fórmula:",
        },
        {
          type: "list",
          items: [
            "Montante final = aporte × (1 + taxa anual / 12)^(12 × anos)",
          ],
        },
        {
          type: "paragraph",
          text: "Calcule:",
        },
        {
          type: "list",
          items: ["Investindo por 1 ano", "Por 3 anos", "Por 5 anos"],
        },
        "Reflexão:",
        {
          type: "list",
          items: [
            "O que te motiva mais: poupar ou ver o dinheiro crescer?",
            "Quanto risco você se sente confortável em assumir hoje?",
          ],
        },
      ],
    },
    {
      id: "ejemplo-real",
      navLabel: "Exemplo real",
      title: "💬 Exemplo real ",
      content: [
        {
          type: "paragraph",
          text: "🎓 Gabriel, 22 anos, estudante de Curitiba, começou a investir R$ 80 por mês no Tesouro Selic aos 18 anos.",
        },
        {
          type: "paragraph",
          text: "Hoje, aos 22, já acumulou mais de R$ 5.000, apenas sendo consistente.",
        },
        {
          type: "paragraph",
          text: "Ele não precisou ganhar muito — apenas começou cedo e não parou.",
        },
        {
          type: "paragraph",
          text: "👉 “Investir me deu sensação de direção. Mesmo investindo pouco, eu vejo resultado.”",
        },
      ],
    },
    {
      id: "quiz",
      navLabel: "Quiz",
      title: "📝 Miniquiz + plano pessoal",
      questions: [
        {
          id: "q1",
          question: "Qual é a principal diferença entre poupar e investir?",
          options: [
            { key: "a", text: "Investir é mais seguro" },
            { key: "b", text: "Investir busca fazer o dinheiro crescer" },
            { key: "c", text: "Poupar é ilegal" },
            { key: "d", text: "Investir sempre dá prejuízo" },
          ],
          correct: "b",
        },
        {
          id: "q2",
          question: "O que são juros compostos?",
          options: [
            { key: "a", text: "Juros sobre gastos" },
            { key: "b", text: "Juros sobre juros acumulados" },
            { key: "c", text: "Um imposto do governo" },
            { key: "d", text: "Desconto para quem atrasa contas" },
          ],
          correct: "b",
        },
        {
          id: "q3",
          question: "O que diz a relação risco × retorno?",
          options: [
            { key: "a", text: "Mais retorno geralmente significa mais risco" },
            { key: "b", text: "Todo investimento é seguro" },
            { key: "c", text: "Investimentos sempre pagam igual" },
            { key: "d", text: "Risco não existe" },
          ],
          correct: "a",
        },
        {
          id: "q4",
          question: "Como reduzir o risco ao investir?",
          options: [
            { key: "a", text: "Diversificar e começar pelo seguro" },
            { key: "b", text: "Colocar tudo em cripto" },
            { key: "c", text: "Gastar antes de investir" },
            { key: "d", text: "Ignorar contratos" },
          ],
          correct: "a",
        },
        {
          id: "q5",
          question: "Qual é a grande vantagem de investir jovem?",
          options: [
            { key: "a", text: "Pagar menos impostos" },
            { key: "b", text: "Mais tempo para o dinheiro crescer" },
            { key: "c", text: "Ter mais cartões" },
            { key: "d", text: "Fugir das dívidas" },
          ],
          correct: "a",
        },
      ],
    },
    {
      id: "investimento",
      navLabel: "Investimento",
      title: "🧠 Seu primeiro plano de investimento",
      content: [
        "Responda para montar sua estratégia:",
        {
          type: "list",
          items: [
            "Quanto você poderia investir por mês?",
            "Qual investimento te parece mais seguro para começar?",
            "Por quanto tempo poderia manter esse investimento?",
            "Que objetivo quer atingir com esse dinheiro?",
            "Segundo a Regra dos 110, quanto você arriscaria hoje?",
          ],
        },
      ],
    },
    {
      id: "bibliografia",
      navLabel: "Bibliografia recomendada",
      title: "📚 Bibliografia recomendada",
      content: [
        "Nathalia Arcuri – “Me Poupe! – 10 passos para nunca mais faltar dinheiro”",
        "Tesouro Direto – Cartilhas para Iniciantes (Banco Central + Tesouro Nacional)",
        "Gustavo Cerbasi – “Investimentos Inteligentes”",
        "Canal Martins Educacional, playlist de Educação Financeira (YouTube)”",
        "App do Banco Central: Registrato e Meu Bolso em Dia (Febraban)",
      ],
    },
    {
      id: "frase",
      navLabel: "Frase do dia",
      title: "🧠 Frase do dia",
      content: [
        "“O melhor momento para investir foi ontem. O segundo melhor é hoje.”",
      ],
    },
  ],
};

export default modulo5_pt;
